module.exports = __webpack_public_path__ + "img/se.f1a5018a.svg";